import { render } from "./Ping.vue?vue&type=template&id=e64d412a"
import script from "./Ping.vue?vue&type=script&lang=js"
export * from "./Ping.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\crescendoCat\\Work Space\\Nodejs\\thripsui\\vue-thripsui\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__